import React, { useEffect, useState } from "react";
import { Route, Switch, useParams } from "react-router-dom";
import { ListingPage, InfosheetPage } from "../pages";
// import InfosheetPage from '../pages/Demo'
import { Provider as ListingProvider } from "../context/ListingContext";
import { Provider as FullscreenProvider } from "../context/FullscreenContext";
import { ModalProvider } from "../context/ModalContext";
import { useStatus } from "../hooks/";
import uplist from "../adapters/uplist";
import { Modal } from "../components";

const useGetListing = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [listing, setListing] = useState();
  useEffect(() => {
    const getResults = async () => {
      try {
        const response = await uplist.get(`/listing/${slug}`);
        setListing(response.data);
        if (process.env.NODE_ENV === "development") {
          console.log("🚀 ~ getResults ~ listing", response.data?.listing);
        }
      } catch {
        setListing({ success: false, message: "Sorry, something went wrong." });
      }
      setLoading(false);
    };
    getResults();
  }, [slug]);
  return { loading, listing };
};

const ListingRoutes = () => {
  const { loading, listing } = useGetListing();
  useStatus({ name: "ListingRoutes", loading, listing });
  if (loading) return null;
  return (
    <ListingProvider value={listing}>
      <ModalProvider>
        <FullscreenProvider>
          <Modal />
          <Switch>
            <Route path="/:slug/infosheet" component={InfosheetPage} />
            <Route exact path="/:slug" component={ListingPage} />
          </Switch>
        </FullscreenProvider>
      </ModalProvider>
    </ListingProvider>
  );
};

export default ListingRoutes;
